import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { HelperService } from 'src/app/services/helper.service';
import { ModalController,NavController } from '@ionic/angular';

@Component({
  selector: 'app-request-cancel',
  templateUrl: './request-cancel.page.html',
  styleUrls: ['./request-cancel.page.scss'],
})
export class RequestCancelPage implements OnInit {
  productId: any;
  paymentMode: any;
  productName: any;
  purchaseAmount: any;

  constructor(private routerActivate: ActivatedRoute,private router : Router, private toast: HelperService,private service : StoreService,
    private navController:NavController) { }

  selectedRadioGroup: any;
  others: boolean;
  orderId:any;
  OrderItem: any={};
  index: any;
  userId: any;
  reason: any;
  flag: any;

  ngOnInit() {
    this.orderId = window.history.state.orderId;
    console.log("order id", this.orderId)

    this.productId = window.history.state.productId;
    console.log("product id", this.productId)

    this.paymentMode = window.history.state.paymentMode;
    console.log("payment mode", this.paymentMode)

    this.productName = window.history.state.productName;
    console.log("product name", this.productName)

    this.purchaseAmount = window.history.state.purchaseAmount;
    console.log("purchase amount", this.purchaseAmount)
    
    this.routerActivate.queryParams.subscribe(params => {
      
    });

    console.log("order Item",this.OrderItem)
      this.userId = localStorage.getItem('userId')
  }
  radioGroupChange(event) {
    this.selectedRadioGroup = event.detail;
    console.log("radioGroupChange",this.selectedRadioGroup);
    if(this.selectedRadioGroup.value==='other')
    {
       this.others=true;
    }
    else{
      this.others=false;
    }
    console.log("others",this.others)
  }
  cancelOrder()
  {
    if(this.selectedRadioGroup!=null){
      if((this.selectedRadioGroup.value=='other' && this.reason!=null)||(this.selectedRadioGroup.value!=null && this.selectedRadioGroup.value!='other')){
        if(this.reason==null || this.reason=='')
        {
          this.reason=this.selectedRadioGroup.value
        }
  
    const promoListobj = {
      "orderId": this.orderId,
      "productId":this.productId,
      "reason": this.reason
    }
    console.log("Cancel order Param", promoListobj)
    this.service.cancelOrder(promoListobj).subscribe((data: any) => {
      this.toast.presentToast("Order has been cancelled successfully",2000,'bottom');
      this.router.navigate(['/order-history'])
    }, (error: any) => {
      console.log("error occurred",error)
      this.toast.presentToast(error,2000,'bottom')
    });
  }
  else if(this.selectedRadioGroup.value=='other' && this.reason==null)
  {
    this.toast.presentToast("Please Enter the Reason for cancellation",2000,'bottom')
  }
}
  else
  {
    this.toast.presentToast("Please select the Reason for cancellation",2000,'bottom')
  }
  }

  goBack() {
    this.navController.pop();
  }

  notifications(){
    this.router.navigate(['/wishlist'])
  }

}
